module.exports = __webpack_public_path__ + "static/media/video-button.a53a6f29.png";